import { render, staticRenderFns } from "./CustomSidebarToggler.vue?vue&type=template&id=52b76e40&"
import script from "./CustomSidebarToggler.vue?vue&type=script&lang=js&"
export * from "./CustomSidebarToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports